<div class="modal-wrapper">
  <span class="close-modal fa fa-close" mat-dialog-close></span>

  <div class="modal-wrapper__content">
    <h2 style="color:red;">Cannot upload file. File type is not supported.</h2>
    <p>Below are the valid file types.</p>
    <ul>
      <li>All valid image file e.g.: .png, .jpg, .bmp, etc</li>
      <li>All valid video file e.g.: .mp4, .mpeg, etc</li>
      <li>Adobe Illustrator encapsulated postScript file(.eps)</li>
      <li>PDF, word, excel, ppt document</li>
    </ul>
  </div>
</div>